import React, {useEffect, useState} from "react";
import {DataTable} from "primereact/datatable";
import TemplatePaginator from "../../../commun/TemplatePaginator/TemplatePaginator";
import {Column} from "primereact/column";
import {ConfirmDialog} from "primereact/confirmdialog";
import ModelVersionColumn from "../ModelVersionColumn/ModelVersionColumn";
import DraftActionButtons from "./ActionBodyTemplate/DraftActionButtons";
import TagList from "../../../DataUpload/CategoriesData/CategoryData/TagList";
import DCTagsFilter from "../../../commun/DCTagsFilter/DCTagsFilter";
import keycloak from "../../../../keycloak";
import {statusFilterProperties} from "../../../../api/utils/filterProperties";

const DraftDataCollections = ({draftList, onCustomPage, first, rows, header, dcListDraft, setDraftList,loading}) => {

    const [idDeleting, setIdDeleting] = useState([]);
    const [allDrafts, setAllDrafts] = useState(draftList);
    const tags = [...new Map(allDrafts.flatMap(dc => dc.allTags).map(tag => [tag.name, tag])).values()];
    const [initialTags, setInitialTags] = useState([...tags.filter(tag => keycloak.idTokenParsed.group.includes(tag.name))]);
    const isSelectable = (id) => !idDeleting.includes(id);
    const rowClassName = (data) => {
        return isSelectable(data.id) ? '' : 'p-disabled'
    };

    const modelVersionColumnTemplate = (rowData) => (<ModelVersionColumn rowData={rowData}/>)
    const applyFilter = (tags) => {
        let result = [...allDrafts];
        if (tags.length !== 0) {
            result = allDrafts.filter(dc =>
                tags.some(tag => dc.allTags.some(dcTag => dcTag.id === tag.id))
            );
        }
        setInitialTags(tags);
        setDraftList(result);
    };
    useEffect(() => {
        var selectedTag = [...tags.filter(tag => keycloak.idTokenParsed.group.includes(tag.name))];
        if (selectedTag.length > 0) {
            applyFilter(selectedTag);
        }
    }, []);

    const actionsBodyTemplateForDraft = (rowData) => (idDeleting.includes(rowData.id) ?
        <div className="flex justify-content-around">
            <span className="vertical-align-middle">Deleting</span>
            <i className="pi pi-spin pi-spinner" style={{fontSize: '1.2rem', padding: '0.15rem'}}></i></div> :
        <DraftActionButtons rowData={rowData} dcListDraft={dcListDraft} setDraftList={setDraftList}
                            setIdDeleting={setIdDeleting} idDeleting={idDeleting}/>)

    const tagsColumnStructure = (r) => {
        return <div><TagList tags={r.allTags}></TagList></div>
    }
    const tagsFilterTemplate = () => {
        return <DCTagsFilter dataCollectionsList={allDrafts} filterDataCollections={setDraftList}
                             TagsList={tags}
                             initialTags={initialTags}
                             onChange={applyFilter}
        />
    }

    return (<div>
        <div className=" card">
            <DataTable value={draftList}
                       header={header}
                       loading={loading}
                       size="small"
                       resizableColumns
                       stripedRows
                       showGridlines
                       paginator paginatorTemplate={TemplatePaginator}
                       filters={statusFilterProperties}
                       first={first} rows={rows} onPage={onCustomPage}
                       paginatorClassName="justify-content-end" className="mt-6 custom-datatable-loading"
                       style={{minHeight: '300px'}}
                       rowClassName={rowClassName}
                       removableSort>
                <Column field="name" sortable header="Name"
                        filter
                        style={{minWidth: "8rem", maxWidth: "10rem", whiteSpace: 'normal', wordWrap: 'break-word'}}/>
                <Column field="startFrom" header="Open from" style={{width: "6rem"}}/>
                <Column field="deadline" header="Deadline" style={{width: "6rem"}}/>
                <Column field="participatingCountries"
                        header="Total participants" style={{width: "8rem"}}/>
                <Column body={modelVersionColumnTemplate}
                        header="PEMMDB Version"
                        field="modelVersionName"
                        filter
                        style={{minWidth: "8rem", maxWidth: "10rem", whiteSpace: 'normal', wordWrap: 'break-word'}}/>
                <Column
                    field="allTags"
                    style={{minWidth: "7rem", maxWidth: "8rem", whiteSpace: 'normal', wordWrap: 'break-word'}}
                    filterMenuStyle={{width: '14rem', height: '6rem'}}
                    body={(r) => tagsColumnStructure(r)}
                    sortable
                    header="Tags"
                    filter
                    showFilterMatchModes={false}
                    showApplyButton={false}
                    showClearButton={false}
                    filterElement={tagsFilterTemplate}/>
                <Column field="copiedFrom.copiedFromDc"
                        header="Copied From"/>
                <Column body={actionsBodyTemplateForDraft} header="Actions "
                        style={{minWidth: "10rem", width: '10rem'}}/>
            </DataTable>
            <ConfirmDialog/>
        </div>
    </div>)
}
export default DraftDataCollections;
